import type {
  HubBrandingItem,
  HubBrandingItemId,
} from '@robovision/hub'
import { FileValue } from './FileValue'


interface BrandingAssetsParams {
  id: HubBrandingItemId
  value?: FileValue | string
}

export class BrandingAssets {
  public readonly id: HubBrandingItemId
  public readonly value?: FileValue | string

  public constructor (params: BrandingAssetsParams) {
    this.id = params.id
    this.value = params.value

    Object.freeze(this)
  }

  public static fromResponse (data: HubBrandingItem) {
    return new BrandingAssets({
      id: data.id,
      value: typeof data.value === 'string' ? data.value : data.value && FileValue.fromResponse(data.value),
    })
  }
}
